export const REGIONS = {
  HK: 'HK',
  TH: 'TH',
  TW: 'TW',
}

export function normalizeRegion(region) {
  return typeof region === 'string' ? region.trim().toUpperCase() : ''
}

export function isRegion(region, targetRegion) {
  return normalizeRegion(region) === normalizeRegion(targetRegion)
}

export function isOneOfRegions(region, targetRegions = []) {
  return targetRegions.some((targetRegion) => isRegion(region, targetRegion))
}

export default {
  REGIONS,
  normalizeRegion,
  isRegion,
  isOneOfRegions,
}
